import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CommentEstablishmentRequest } from "../interface/comment-establishment.interface";
import { environment } from "../../../../../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CommentEstablishmentService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {

  }

  commentEstablishment(data: CommentEstablishmentRequest): Observable<{ status: boolean, message: string }> {
    return this.http.post<{ status: boolean, message: string }>(`${this.apiUrl}/comments/add`, data);
  }

  commentDelivery(data: CommentEstablishmentRequest): Observable<{ status: boolean, message: string }> {
    return this.http.post<{ status: boolean, message: string }>(`${this.apiUrl}/commentsDelivery/add`, data);
  }
}
